<template>
  <div style="margin-bottom:15px;margin-top:15px;" :style="{'--datepicker-color': $store.getters.getRadioButtonColor}">
    <div v-for="model in question.answers" v-bind:key="model.uid">
      <label
          :for="question.uid" v-bind:class="{ selected: model.selected }">
      </label>
      <datetime type="datetime"
                :min-datetime="min"
                v-model="model.value"
                input-class="form-control"
                :phrases="{ok: $t('ui.nextButton'), cancel: $t('ui.cancel')}"
      ></datetime>
      <input v-bind:value="formatDatetime(model.value)"
             class="form-control"
             :placeholder="model.title"
             :name="question.uid"
             type="hidden"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'datetime-picker',
  props: ['question'],
  data() {
    return {
      date: '',
      min: ''
    }
  },
  mounted() {
    this.min = new Date().toISOString();
  },
  methods: {
    formatDatetime(value) {
      if (value) {

        let obj = new Date(value);

        let minutes = obj.getMinutes() == 0 ? '00' : obj.getMinutes();

        if (minutes > 0 && minutes <= 9 && minutes !== '00') {
            minutes = '0' + minutes
        }

        return new Date(obj.getTime() - (obj.getTimezoneOffset() * 60000))
            .toISOString()
            .split("T")[0] + ` ${obj.getHours()}:${minutes}`;
      }

      return '';
    }
  },
  components: {}
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .10s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
  opacity: 0;
}
</style>
